export default __webpack_public_path__ + "static/media/Q8.3150e540.jpg";